import { render, staticRenderFns } from "./news_course.vue?vue&type=template&id=11dacf60&scoped=true&"
import script from "./news_course.vue?vue&type=script&lang=js&"
export * from "./news_course.vue?vue&type=script&lang=js&"
import style0 from "./news_course.vue?vue&type=style&index=0&id=11dacf60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dacf60",
  null
  
)

export default component.exports